// Configuration for the Nightwing LLM application

export const config = {
  // Cloudflare Configuration
  cloudflare: {
    accountId: 'a2043ce2d5ddcd745ba2eafda7dcde8d',
    gatewayName: 'nightwing-llm',
    // OpenAI API Key is configured in the worker function
  },

  // API Configuration
  api: {
    analyzeEndpoint: '/api/analyze-video',
    timeout: 60000, // 60 seconds
  },

  // Video Upload Configuration
  upload: {
    maxFileSize: 150 * 1024 * 1024, // 150MB
    acceptedFormats: ['video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo'],
    acceptedExtensions: ['.mp4', '.webm', '.mov', '.avi'],
  },

  // UI Configuration
  ui: {
    theme: {
      primary: {
        start: '#667eea',
        end: '#764ba2',
      },
      background: '#0f1419',
      card: {
        dark: '#1e293b',
        light: '#334155',
      },
      text: {
        primary: '#e2e8f0',
        secondary: '#8b92a8',
        muted: '#cbd5e1',
      },
      status: {
        success: '#34d399',
        warning: '#fbbf24',
        error: '#f87171',
      },
    },
  },

  // Analysis Configuration
  analysis: {
    scoreThresholds: {
      excellent: 75,
      good: 50,
      needsWork: 0,
    },
  },
}

export default config

